<template>
  <b-row class="trust-badges">
    <b-col
      v-for="badge in badges"
      :key="badge.icon"
      md="4"
      class="trust-badges__element"
    >
      <feature-card
        class="trust-badges__card h-100"
        :icon="badge.icon"
        :title="badge.title"
        :caption="badge.caption"
        icon_background_color="#e9ecef"
        centered
        radius
      />
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'trust-badges',

    data() {
      return {
        // rassicurazioni sull'acquisto, sopra il riepilogo (testi dal Figma)
        badges: [
          {
            icon: 'shield',
            title: 'Pagamento sicuro',
            caption: 'Tramite portale welfare.',
          },
          {
            icon: 'email',
            title: 'Consegna immediata',
            caption: 'Nella tua casella email tra pochi minuti.',
          },
          {
            icon: 'c-card',
            title: 'Nessun costo extra',
            caption: 'Zero commissioni di emissione o attivazione.',
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>

  .trust-badges {
    margin-top: $grid-gutter-width;

    &__element {
      margin-bottom: $grid-gutter-width / 2;

      @include media-breakpoint-up(md) {
        margin-bottom: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    // qui le card sono più compatte del default del componente condiviso:
    // padding 15 invece di 20 e badge icona da 36px invece di 44
    &__card {
      padding: $grid-gutter-width / 2;

      ::v-deep .feature-card__icon {
        padding: 6px;
        margin-bottom: 8px;
      }
    }
  }
</style>